<template>
  <div class="text-field" :class="feelingClass">
    <label class="text-field__label" :for="id">{{ label }}</label>
    <input
      class="text-field__input"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
      :type="type"
      :id="id"
      :placeholder="placeholder"
      :disabled="disabled"
    />
    <span v-if="helper" class="text-field__helper">{{ helper }}</span>
  </div>
</template>

<script>
export default {
  name: 'TextField',
  props: {
    value: {
      type: String,
    },
    type: {
      type: String,
      required: true,
      validator: (prop) => [
        'text',
        'password',
        'url',
      ].includes(prop),
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    id: {
      type: String,
      required: true,
    },
    helper: {
      type: String,
    },
    feeling: {
      type: String,
      validator: (prop) => [
        'positive',
        'highligted',
        'pending',
        'muted',
        'negative',
      ].includes(prop),
    },
    disabled: {
      type: Boolean,
    },
  },
  computed: {
    feelingClass() {
      return this.feeling ? `text-field--${this.feeling}` : false;
    },
  },
};
</script>

<style scoped>
.text-field {
  display: flex;
  flex-direction: column;
  width: 16rem;
}

.text-field__label {
  margin-bottom: var(--unit-extra-small);
  margin-left: calc(2 * var(--unit-extra-small));
  font-weight: bold;
}

.text-field__input {
  display: inline-block;
  padding: var(--unit-extra-small);
  border-radius: var(--token-border-radius-small);
  border: var(--unit-extra-small) solid transparent;
  background-color: var(--token-color-fill-light);
  outline: none;
}

.text-field__input:hover {
  box-shadow: var(--token-glow);
}

.text-field__input:focus {
  background-color: var(--token-color-fill-highlighted);
  box-shadow: var(--token-glow-highlighted);
}

.text-field__helper {
  margin-top: var(--unit-extra-small);
  margin-left: calc(2 * var(--unit-extra-small));
  font-size: var(--token-body-size-small);
  line-height: var(--token-body-line-small);
}

.text-field--positive .text-field__helper {
  color: var(--token-color-body-positive);
}

.text-field--negative .text-field__helper {
  color: var(--token-color-body-negative);
}
</style>
